export enum StatusScrenningEnum {
  Recording = 1,
  Imei = 2,
  Checklist = 3,
  Result = 4,
  DivergenceReport = 5
}

export const statusScrenningText = {
  1: 'Gravação',
  2: 'Imei',
  3: 'Checklist',
  4: 'Resultado',
  5: 'Laudo de Divergência',
};

export const ScrenningStepText = {
  gravacao: 'Gravação',
  imei: 'Imei',
  checklist: 'Checklist',
  resultado: 'Resultado',
  laudo: 'Laudo de divergência'
};

export const statusScrenningRoute = {
  1: 'gravacao',
  2: 'imei',
  3: 'checklist',
  4: 'resultado',
  5: 'laudo-divergencia',
};
